"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledControlSeparator = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const SeparatorSize_1 = require("./types/SeparatorSize");
const helpers_1 = require("../../helpers");
const HEIGHT_SIZES = {
    [SeparatorSize_1.SEPARATOR_SIZE.xs]: helpers_1.SIZE_M,
    [SeparatorSize_1.SEPARATOR_SIZE.s]: helpers_1.SIZE_M,
    [SeparatorSize_1.SEPARATOR_SIZE.m]: helpers_1.SIZE_L,
    [SeparatorSize_1.SEPARATOR_SIZE.l]: helpers_1.SIZE_XL,
    [SeparatorSize_1.SEPARATOR_SIZE.xl]: helpers_1.SIZE_XXL,
    [SeparatorSize_1.SEPARATOR_SIZE.full]: '100%'
};
exports.StyledControlSeparator = styled_components_1.default.div `
    flex-shrink: 0;
    height: ${({ size }) => HEIGHT_SIZES[size]};
    width: 1px;
    background: ${({ theme }) => theme.colors.borders.normal};
`;
//# sourceMappingURL=ControlSeparator.styles.js.map